/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import cx from "classnames";

import Button, { Props as ButtonProps } from "components/Button";

import styles from "./SettingsSubscriptionButton.module.scss";

export const SettingsSubscriptionButton: React.FC<ButtonProps> = ({
  children,
  className,
  ...restProps
}) => {
  return (
    <Button
      size="medium"
      className={cx(styles.button, className)}
      {...restProps}
    >
      {children}
    </Button>
  );
};

export default SettingsSubscriptionButton;
